import React, { ReactNode } from 'react';
import {
  QuoteCarIcon,
  QuoteCarWhiteIcon,
  QuoteContainerIcon,
  QuoteContainerWhiteIcon,
  QuoteTruckIcon,
  QuoteTruckWhiteIcon,
} from 'svgs';

export type TActiveTypes = 'truckload' | 'intermodal' | 'lessTruckload';

export interface IconCardProps {
  onSelect: TActiveTypes;
  icon: ReactNode;
  activeIcon: ReactNode;
  text: string;
}

export const iconCards: IconCardProps[] = [
  {
    activeIcon: <QuoteTruckWhiteIcon />,
    onSelect: 'truckload',
    text: 'Full Truckload',
    icon: <QuoteTruckIcon />,
  },
  {
    activeIcon: <QuoteContainerWhiteIcon />,
    onSelect: 'intermodal',
    text: 'Intermodal',
    icon: <QuoteContainerIcon />,
  },
  {
    activeIcon: <QuoteCarWhiteIcon />,
    onSelect: 'lessTruckload',
    text: 'Less-than-truckload',
    icon: <QuoteCarIcon />,
  },
];
